module.exports = __webpack_public_path__ + "static/1-37adb062bc59e5d55551a0d0e0e459af.jpg";